module.exports = __webpack_public_path__ + "img/helpinfo.985ce914.png";